export default "__VITE_ASSET__BQx3ABc6__"